import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Instagram Stories on desktop: the story centred in a desktop window, with
 * the player controls in its header. The reference shows no link sticker here.
 */
@Component({
  selector: 'app-meta-instagram-desktop-stories',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-desktop-stories.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './instagram-desktop-stories.component.scss',
  ]
})
export class MetaInstagramDesktopStoriesPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;
}
